/**
 * Safely extract an error message from an unknown error value.
 * Handles Error instances, objects with a message property, and string errors.
 */
export function getErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error) {
    return err.message || fallback;
  }
  if (typeof err === 'object' && err !== null && 'message' in err) {
    const msg = (err as { message: unknown }).message;
    if (typeof msg === 'string' && msg.length > 0) {
      return msg;
    }
  }
  if (typeof err === 'string' && err.length > 0) {
    return err;
  }
  return fallback;
}
